import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './lib/LanguageContext';
import { LanguageToggle } from './components/LanguageToggle';
import { HomePage } from './pages/HomePage';
import { WhyWhiteBoxPage } from './pages/WhyWhiteBoxPage';
import { ProductsPage } from './pages/ProductsPage';
import { IndustryPage } from './pages/IndustryPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  useEffect(() => {
    // Google tag (gtag.js)
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MKW2FP1FZN';
    script.async = true;
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-MKW2FP1FZN');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/why-white-box" element={<WhyWhiteBoxPage data-id="element-6" />} data-id="element-5" />
          <Route path="/products" element={<ProductsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/industry" element={<IndustryPage data-id="element-10" />} data-id="element-9" />
          <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
        </Routes>
        <LanguageToggle data-id="element-15" />
      </BrowserRouter>
    </LanguageProvider>;
}